import React from "react"

import Rectangle from "../../images/svg/Rectangle 1001.svg"

const linehome = () => {
  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <img src={Rectangle} alt="Rectangle" className="img-fluid"></img>
          </div>
        </div>
      </section>
    </>
  )
}

export default linehome
